import clsx from "clsx";
import { IoLogoLinkedin, IoMailOutline } from "react-icons/io5";
import { Badge } from "../badge";
import { Card as CardProps } from "./index.types";
import "./index.css";

export function Card(props: CardProps) {
  const { className } = props;

  if (props.variant === "team") {
    const { photo, name, role, bio, linkedin, email } = props;
    return (
      <div className={clsx("card", "card--team", className)}>
        <img src={photo} alt={name} className="card__photo" />
        <div className="card__name">{name}</div>
        <div className="card__role">{role}</div>
        <div className="card__bio">{bio}</div>
        <div className="card__links">
          <a
            href={linkedin}
            target="_blank"
            rel="noopener"
            aria-label="LinkedIn"
          >
            <IoLogoLinkedin className="card__icon" />
          </a>
          <a href={`mailto:${email}`} aria-label="Email">
            <IoMailOutline className="card__icon" />
          </a>
        </div>
      </div>
    );
  }

  if (props.variant === "use-case") {
    const { icon, title, comingSoon, children } = props;
    return (
      <div
        className={clsx(
          "card",
          "card--use-case",
          { "card--coming-soon": comingSoon },
          className
        )}
      >
        <div className="card__icon-wrap">
          <img src={icon} alt="" />
        </div>
        <h4>
          {title}
          {comingSoon && (
            <Badge size="sm" tone="chrome">
              Coming Soon
            </Badge>
          )}
        </h4>
        <p>{children}</p>
      </div>
    );
  }

  const { num, title, children } = props;
  return (
    <div className={clsx("card", "card--default", className)}>
      <div className="card__num">{num}</div>
      <h3>{title}</h3>
      <p>{children}</p>
    </div>
  );
}

export default Card;
